
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["loadModel","disposeModel","predict"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "56f6d3123c1e23b306a7.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			